import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SidebarContent } from './SidebarContent';

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [SidebarContent],
});
